import React from 'react'
import './experience.css'
import {BsPatchCheckFill} from 'react-icons/bs'
import {AiFillHtml5} from 'react-icons/ai'
import {IoLogoJavascript} from 'react-icons/io'
import {IoLogoCss3} from 'react-icons/io'
import {GrReactjs} from 'react-icons/gr'
import {FaNodeJs} from 'react-icons/fa'
import {SiMysql} from 'react-icons/si'
import {SiPhp} from 'react-icons/si'
import {SiOracle} from 'react-icons/si'
import {SiJava} from 'react-icons/si'
import {RiAngularjsFill} from 'react-icons/ri'

const Experience = () => {
  return (
    <section id='experience'>
      <h5>Skills & Capabilities</h5>
      <h2>What I Bring</h2>

      <div className='container experience__container'>
        <div className='experience__frontend'>
          <h3>Technical Skills</h3>
          <div className='experience__content'>
            <article className='experience__details'>
              <GrReactjs className='experience__details-icon' />
              <div>
                <h4>React & Frontend</h4>
              </div>
            </article>
            <article className='experience__details'>
              <SiJava className='experience__details-icon' />
              <div>
                <h4>Java & Spring Boot</h4>
              </div>
            </article>
            <article className='experience__details'>
              <FaNodeJs className='experience__details-icon' />
              <div>
                <h4>Node.js & APIs</h4>
              </div>
            </article>
            <article className='experience__details'>
              <SiOracle className='experience__details-icon' />
              <div>
                <h4>Oracle & SQL</h4>
              </div>
            </article>
            <article className='experience__details'>
              <SiMysql className='experience__details-icon' />
              <div>
                <h4>Kubernetes & Container Deployment</h4>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Python</h4>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>JavaScript</h4>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>REST APIs</h4>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>JSON & XML</h4>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>HTML5 & CSS</h4>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Angular</h4>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>CI/CD & Deployment Pipelines</h4>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Docker & Container Platforms</h4>
              </div>
            </article>
          </div>
        </div>

        <div className='experience__backend'>
          <h3>Customer Success & Consulting</h3>
          <div className='experience__content'>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Communication Skills</h4>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Critical Thinking</h4>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Enterprise Architecture</h4>
                <small className='text-light'>System Design & Integration</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Performance Optimization</h4>
                <small className='text-light'>27% improvement achieved</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Requirements Gathering</h4>
                <small className='text-light'>Impact Assessment</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Production Support</h4>
                <small className='text-light'>~20 incidents/month</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Incident Troubleshooting</h4>
                <small className='text-light'>Root Cause Analysis</small>
              </div>
            </article>
          </div>
        </div>

        <div className='experience__leadership'>
          <h3>Tools & Platforms</h3>
          <div className='experience__content'>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Security & Compliance</h4>
                <small className='text-light'>RBAC, SSO, OAuth, Fortify</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Monitoring & Alerting</h4>
                <small className='text-light'>Splunk, Logging & Metrics</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>CI/CD & Release</h4>
                <small className='text-light'>Jenkins, Deployment Validation</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>API & Integration</h4>
                <small className='text-light'>REST APIs, OAuth, Security</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Documentation</h4>
                <small className='text-light'>Runbooks & Knowledge Transfer</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Git & Version Control</h4>
                <small className='text-light'>GitHub, Confluence</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Troubleshooting & Debugging</h4>
                <small className='text-light'>Log Analysis, API Testing</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Production Support</h4>
                <small className='text-light'>Incident Management, Escalation</small>
              </div>
            </article>
          </div>
        </div>

        </div>
    </section>
  )
}

export default Experience